<template>
  <div v-if="loaded">
    <div class="table_sec">
      <div class="md-layout-item md-size-100 page">
        <div class="section_body">
        <div class="section_title">
          <h2>Cash Tables</h2>
        </div>
        <div class="tble-box">

          <div class="tbl-title">
            <h4>Percentages</h4>
          </div>
          <div class="inner-tbl">
             <md-table
                                    v-model="tableAnnualCashRatiosPercent"
                                   table-header-color="blue"
                                    class="dark_blue"
                                    style="flex: 1;"
                                  >
                                    <md-table-row
                                      slot="md-table-row"
                                      slot-scope="{ item }"
                                    >
                                      <md-table-cell md-label="Annual Cash Ratios" class="md-table-side-label">
                                        {{ item.name }}
                                        <md-tooltip md-direction="bottom">{{
                                          item.rollover
                                        }}</md-tooltip>
                                      </md-table-cell>

                                      <!-- <md-table-cell md-label="Trend" class="table_chart">
                                        <chart-card
                                          header-animation="false"
                                          :chart-data="colouredLineChart.data"
                                          :chart-options="colouredLineChart.options"
                                          chart-type="Line"
                                          header-icon
                                          chart-inside-content
                                          no-footer
                                          background-color="blue"
                                        >
                                        </chart-card>
                                      </md-table-cell> -->

                                      <md-table-cell
                                        v-for="key in Object.keys(item.dates)"
                                        :key="key"
                                        :md-label="key"
                                        >{{ item.dates[key] }}%
                                      </md-table-cell>
                                    </md-table-row>
             </md-table>
          </div>

        </div>
        <div class="tble-box">
          <div class="tbl-title">
            <h4>Dollars</h4>
          </div>
          <div class="inner-tbl">
              <md-table
              v-model="tableAnnualCashRatiosDollar"
              table-header-color="blue"
              class="dark_blue"
              style="flex: 1;"
              >
              <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              >
              <md-table-cell md-label="Annual Cash Ratios" class="md-table-side-label">
              {{ item.name }}
              <md-tooltip md-direction="bottom">{{
              item.rollover
              }}</md-tooltip>
              </md-table-cell>

              <!-- <md-table-cell md-label="Trend" class="table_chart">
              <chart-card
              header-animation="false"
              :chart-data="colouredLineChart.data"
              :chart-options="colouredLineChart.options"
              chart-type="Line"
              header-icon
              chart-inside-content
              no-footer
              background-color="blue"
              >
              </chart-card>
              </md-table-cell> -->

              <md-table-cell
              v-for="key in Object.keys(item.dates)"
              :key="key"
              :md-label="key"
              >${{ item.dates[key] }}
              </md-table-cell>
              </md-table-row>
              </md-table>


          </div>

           <div class="inner-tbl">
               <md-table
                                      v-model="worksheet"
                                      table-header-color="blue"
                                    class="dark_blue"
                                    style="flex: 1;"
                                    >
                                      <md-table-row
                                        slot="md-table-row"
                                        slot-scope="{ item }"
                                      >
                                        <md-table-cell md-label="Worksheet">{{
                                          item.title
                                        }}</md-table-cell>

                                        <!-- <md-table-cell md-label="Trend" class="table_chart">
                                          <chart-card
                                            header-animation="false"
                                            :chart-data="colouredLineChart.data"
                                            :chart-options="colouredLineChart.options"
                                            chart-type="Line"
                                            header-icon
                                            chart-inside-content
                                            no-footer
                                            background-color="blue"
                                          >
                                          </chart-card>
                                        </md-table-cell> -->

                                        <md-table-cell
                                          v-for="key in Object.keys(item.dates)"
                                          :key="key + 'worksheet'"
                                          :md-label="key"
                                          >{{ item.dates[key] }}</md-table-cell
                                        >
                                      </md-table-row>
                                    </md-table>
           </div>

        </div>
        <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { NavTabsCard, ChartCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';

export default {
  components: {
    // ChartCard,
  },
  mixins: [formatData],
  props: ['headerData'],
  data() {
    return {
      colouredLineChart: {
        data: {
          labels: [1, 2, 3, 4, 5],
          series: [
            [1, 5, 3, 4, 2]
          ]
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 1,
          }),
          chartPadding: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
          },
          axisY: {
            showGrid: false,
            showLabel: false,
            offset: 0,
          },
          axisX: {
            showGrid: false,
            showLabel: false,
            offset: 0,
            scaleMinSpace: 6
          },
          showPoint: true,
          showLabel: false,
          width: "100px",
          height: "25px",
          seriesBarDistance: 10,
          fullWidth: true,
        },
      },
      changein: [],
      worksheet: [],
      tableAnnualCashRatiosDollar: [],
      tableAnnualCashRatiosPercent: [],
      display_source_uses: false,
      loaded:false,
    };
  },
  computed: {
    ...mapState({
      data: (state) => state.user.profile.data.data,
      // sourcesUses: (state) => state.user.report.data['sourcesUses'],
      // years: (state) => state.user.report.data['sourcesUses']['years'],
       profile: (state) => state.user.profile,
      showYears: (state) => state?.user?.profile?.data ? state.user.profile.data.showYears : null,
      annualCashRatiosDollar: (state) =>
        state.user.profile.data.tables.annual_cash_ratios_dollar,
      annualCashRatiosPercent: (state) =>
        state.user.profile.data.tables.annual_cash_ratios_percent,
      report: (state) => state.user.profile.data,
    }),
  },
  mounted() {
    this.init();
  },
  methods: {
    formatData(table, data) {
      let getDates = (id) =>
        this.years.reduce((acc, cur, index) => {
          let value = this.actualData[this.years.length - index - 1][id];

          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },

    init(){
        let filtered_years = [];

      if (!this.showYears) {
        return;
      }
      Object.keys(this.showYears).forEach((k, i) => {
      if (this.showYears[k] && this.years) {
        filtered_years.push(this.years[i]);
      }
      });
      if (!filtered_years.length) {
      filtered_years = this.years;
      }

      this.tableAnnualCashRatiosDollar = this.formatTable(
      this.annualCashRatiosDollar,
      'industry',
      'dollar'
      );
      this.tableAnnualCashRatiosDollar = this.tableAnnualCashRatiosDollar.map(
      (item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return filtered_years && !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      }
      );

      this.tableAnnualCashRatiosPercent = this.formatTable(
      this.annualCashRatiosPercent,
      'industry',
      'percent'
      );
      this.tableAnnualCashRatiosPercent = this.tableAnnualCashRatiosPercent.map(
      (item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return filtered_years && !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      }
      );

      this.changein = this.changein.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
      });
      this.worksheet = this.worksheet.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
      });
       this.loaded=true;
    }
  },

  watch: {
     profile(newVal, oldVal) {
      this.init();
    }
  },
};
</script>
<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}
.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}
</style>
